import { createTheme } from "@mui/material/styles";
import { colors, alpha } from "@mui/material";
import typography from "./typography";

// Light theme for this app
const lightTheme = createTheme({
  typography: typography,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          "&.Mui-disabled": {
            background: "rgba(0, 0, 0, 0.12)",
          },
        },
        containedPrimary: {
          background:
            "linear-gradient(292deg, #732668 0.1%, #402673 50.05%, #2F2673 100%)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          // background: "#f5f5f5",
          fontWeight: 400,
          // color: "rgba(0, 0, 0, 0.6)",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "&.Mui-checked": {
            color: "rgba(0, 0, 0, 0.87)",
          },
          "&.MuiCheckbox-indeterminate": {
            color: "rgba(0, 0, 0, 0.87)",
          },
        },
      },
    },
  },
  palette: {
    background: {
      default: "#ffffff",
      dark: "#fafafa",
      light: "#F5F5F5",
      paper: colors.common.white,
    },
    primary: {
      main: "#3F51B5",
      light: "#C5CAE9",
      dark: "#303F9F",
      lightest: "#C5CAE9",
      darkest: "#455A64",
      lightBg: "#E8EAF6",
    },
    secondary: {
      light: "#8C9EFF",
      main: "#536DFE",
      dark: "#3D5AFE",
      lightest: "#F6FAFD",
    },
    success: {
      main: "#2E7D32",
    },
    divider: alpha("#000000", 0.12),
    light:
      "linear-gradient(292deg, #732668 0.1%, #402673 50.05%, #2F2673 100%)",
    dark: "linear-gradient(297deg, #EF8FE2 12.49%, #B08FEF 56.24%, #9A8FEF 100%)",
    accentGradient:
      "linear-gradient(311deg, #BF40AE 0%, #6B40BF 50%, #4E40BF 100%)",
    accent: "#BF40AE",
    selection: "#E8EAF6",
    lightColor: "#732668",
    lightBackgroundGradient:
      "linear-gradient(311deg, #BF40AE 0%, #6B40BF 50%, #4E40BF 100%);",
    paper:
      "linear-gradient(280deg, #E3DFFC 0.82%, #FEFEFF 50.21%, #FCF2FD 99.6%)",
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.6)",
    },
  },
});

// Dark theme
const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#0B1215",
      dark: "#0E171B",
      light: "#101C21",
      paper: "#122229",
    },
    primary: {
      main: "#23E0D2",
      light: "#6CF2E6",
      dark: "#159890",
      lightest: "#C5CAE9",
      darkest: "#3F51B5",
      lightBg: "#13252A",
    },
    secondary: {
      light: "#A5B4FC",
      main: "#13252A",
      dark: "#5C6BC0",
      lightest: "#2A2A2A",
    },
    info: {
      main: "#42C6FF",
    },
    success: { main: "#2ED58A" },
    warning: { main: "#F5B947" },
    error: { main: "#FF6E6E" },
    action: {
      hover: "#0F1D22",
      active: "#159890",
      disabledBackground: "#154044",
    },
    divider: "#17343A",
    light: "#E8FBFB",
    dark: "linear-gradient(297deg, #EF8FE2 12.49%, #B08FEF 56.24%, #9A8FEF 100%)",
    accentGradient: "#E8FBFB",
    accent: "#E8FBFB",
    selection: "#13252A",
    purpleLighten5: "#2A1A2E",
    purplePurple: "#BA68C8",
    lightBlueDarken4: "#4FC3F7",
    lightBlueLighten5: "#1A2A3A",
    lightBackgroundGradient:
      "linear-gradient(311deg, #BF40AE 0%, #6B40BF 50%, #4E40BF 100%);",
    paper:
      "linear-gradient(280deg, #2A1F3D 0.82%, #1E1E1E 50.21%, #2D1F2D 99.6%)",
    text: {
      primary: "#E8FBFB",
      secondary: "#B6D7D9",
      disabled: "#6A8D8F",
      tertiary: "#87AEB1",
    },
  },
  typography: typography,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 50,
          "&.Mui-disabled": {
            background: "rgba(255, 255, 255, 0.12)",
          },
        },
        textPrimary: {
          color: "#9FEDE7",
        },
        outlinedPrimary: {
          borderColor: "#1F4D55",
          backgroundColor: "#13252A",
          color: "#CFE7E8",
        },
        containedPrimary: {
          color: "#092728",
          background: "#23E0D2",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundImage: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "#E8FBFB",
        },
      },
    },
  },
});

// Default export for backward compatibility (light theme)
const theme = darkTheme;

export default theme;
export { lightTheme, darkTheme };
